import { useEffect, useState } from "react";
import { TitleBar } from "../../components/TitleBar";
import { CustomTabs } from "../../components/CustomTabs";
import useAuth from "../../hook/useAuth";
import { AddChild } from "../../components/AddChild";
import { CustomDataGrid } from "../../components/CustomDataGrid";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import baseURL from "../../config/api";
import { PleasewaitPopup } from "../../components/PleasewaitPopup";
import { delete_EnrollmentChild, post_ResendInvitToChild } from "../../services/Parent";
import useDelete from "../../hook/useDelete";
import DeletePopup from "../../components/DeletePopup";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { statusColorCode } from "../../utils/statusColorCode";

const tabs = ["Invited Child's", "Child's Progress"];

export const ParentDashboard = () => {
    const { auth }: any = useAuth();
    const location = useLocation();
    const previousRoute = location.state?.from;
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [showAddChildPopup, setShowAddChildPopup] = useState<boolean>(false);
    const [refreshChildList, setChildRefreshList] = useState<boolean>(false);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);
    const invitedChildsColumns: GridColDef[] = [
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "userName",
            headerName: "User Name",
            type: "number",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "emailAddress",
            headerName: "Email Address",
            editable: false,
            sortable: false,
            flex: 1,
            minWidth: 120,
        },
        {
            field: "mobilPhoneNumber",
            headerName: "Phone Number",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "courseName",
            headerName: "Course Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "enrolledStatus",
            headerName: "Status",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                let color = {
                    colorBg: "#000000",
                    colorText: "#000000"
                };
                color = statusColorCode?.find((color: any) => color?.label === params?.value?.trim()?.toLowerCase()) || {
                    colorBg: "#000000",
                    colorText: "#000000"
                };

                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },
        {
            field: "invitationId",
            headerName: "Actions",
            type: "actions",
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Delete"
                    onClick={() => { handleOnDeleteChild(params.row.invitationId) }}
                />,
                <GridActionsCellItem
                    showInMenu={true}
                    icon={null}
                    label="Re-send invite"
                    onClick={() => { handleReInviteChild(params.row.invitationId) }}
                />,

            ]
        }
    ];
    const childsProgressColumns: GridColDef[] = [
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <span className="underline text-[#0000ff] cursor-pointer" onClick={() => {
                        navigate("/parent/childs/progress", { state: { id: params?.row?.childId, name: params?.row?.firstName + " " + params?.row?.lastName, courseName: params?.row?.courseName, courseId: params?.row?.courseId } })
                    }}>
                        {params?.value}
                    </span>
                );
            },
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "userName",
            headerName: "User Name",
            type: "number",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "emailAddress",
            headerName: "Email Address",
            editable: false,
            sortable: false,
            flex: 1,
            minWidth: 120,
        },
        {
            field: "mobilPhoneNumber",
            headerName: "Phone Number",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "courseName",
            headerName: "Course Name",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "progressValue",
            headerName: "Progress Value",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "totalValue",
            headerName: "Total Value",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "progress",
            headerName: "Progress",
            flex: 1,
            minWidth: 120,
            editable: false,
            sortable: false,
            renderCell: (params) => {

                return (
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress
                            variant="determinate"
                            value={params.value}
                            enableTrackSlot
                        />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                variant="caption"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >{`${Math.round(params.value)}%`}</Typography>
                        </Box>
                    </Box>
                );
            }
        },

    ];

    useEffect(() => {
        if (previousRoute === "child-progress") {
            setActiveIndex(1)
        }
        else {
            setActiveIndex(0);
        }
    }, [previousRoute])


    useEffect(() => {
        const newPaginationModel = {
            page: 0,
            pageSize: 10,
        };

        setPaginationModel(newPaginationModel);
        setSearchTableData([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex])

    useEffect(() => {
        if (refreshChildList) {
            const newPaginationModel = {
                page: 0,
                pageSize: 10,
            };
            setPaginationModel(newPaginationModel);
            setChildRefreshList(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshChildList]);

    useEffect(() => {
        if (auth?.id && activeIndex === 0) {
            invitedChildsApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, auth, activeIndex])


    const invitedChildsApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}users/GetChildsByParentId/${auth?.id},${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.users?.map((item: any, index: number) => {
                    return {
                        id: index,
                        enrollmentClassId: item.enrollmentClassId,
                        firstName: item.firstName,
                        lastName: item.lastName,
                        userName: item.userName,
                        emailAddress: item.emailAddress,
                        mobilPhoneNumber: item.mobilPhoneNumber,
                        courseName: item.courseName,
                        childId: item.childId,
                        invitationId: item.invitationId,
                        enrolledStatus: item.enrolledStatus
                    };
                })
                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });
    }

    useEffect(() => {
        if (auth?.id && activeIndex === 1) {
            childsProgressApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, auth, activeIndex])


    const childsProgressApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}users/GetChildsByParentIdWithProgress/${auth?.id},${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.users?.map((item: any, index: number) => {
                    return {
                        id: index,
                        childId: item?.childId,
                        courseId: item?.courseId,
                        firstName: item.firstName,
                        lastName: item.lastName,
                        userName: item.userName,
                        emailAddress: item.emailAddress,
                        mobilPhoneNumber: item.mobilPhoneNumber,
                        courseName: item.courseName,
                        progressValue: item?.progressValue,
                        totalValue: item?.totalValue,
                        progress: item?.progressValue > 0 ? (item.progressValue / item.totalValue) * 100 : 0
                    };
                })
                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });
    }

    const hanbleTabChange = (index: number) => {
        setActiveIndex(index);
    }


    const handleReInviteChild = (id: number) => {
        if (id) {
            setShowPleasewait(true);
            post_ResendInvitToChild(id, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setChildRefreshList(true);
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const handleOnDeleteChild = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this child?`,
                isDelete: (callback: any) => {
                    delete_EnrollmentChild(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setChildRefreshList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }


    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar
                    title={"Welcome, " + auth?.givenname}
                    subTitle="Parent Dashboard"
                />

                <div className="w-full py-8">
                    <CustomTabs
                        tabs={tabs}
                        activeIndex={activeIndex}
                        onChange={(index) => hanbleTabChange(index)}
                    />

                    {
                        activeIndex === 0 && (
                            <div className="w-full">
                                <div className="w-full mt-4 flex justify-end items-center py-4">
                                    <button
                                        className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                        onClick={() => setShowAddChildPopup(true)}
                                    >
                                        Add a child
                                    </button>
                                </div>

                                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>

                                    <CustomDataGrid
                                        filteredRows={searchTableData}
                                        columns={invitedChildsColumns?.map(col => ({
                                            ...col,
                                            headerClassName: "bg-[#F9FAFB]",
                                        }))}
                                        loading={loading}
                                        totalLength={totalLength}
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}

                                    />
                                </div>
                            </div>
                        )
                    }

                    {
                        activeIndex === 1 && (
                            <div className="w-full">

                                <div className={`w-full border border-[#E4E7EC] rounded-[16px] mt-6`}>

                                    <CustomDataGrid
                                        filteredRows={searchTableData}
                                        columns={childsProgressColumns?.map(col => ({
                                            ...col,
                                            headerClassName: "bg-[#F9FAFB]",
                                        }))}
                                        loading={loading}
                                        totalLength={totalLength}
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}

                                    />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
            {
                showAddChildPopup && (
                    <AddChild showPopup={showAddChildPopup} setShowPopup={setShowAddChildPopup} setRefreshChildList={setChildRefreshList} />
                )
            }

            <PleasewaitPopup showPopup={showPleasewait} />

            <DeletePopup />
        </>

    )
}